module.exports = __webpack_public_path__ + "static/media/mobile_logo.bf26e40a.png";